module.exports = __webpack_public_path__ + "static/media/temp.166d38db.svg";